export const CoreInfoRequestExcelHeaders = [
  {
    header: "REF NO",
    key: "REF NO",
    width: 25,
  },
  {
    header: "CUSTOMER NAME",
    key: "CUSTOMER NAME",
  },
  {
    header: "PN",
    key: "PN",
  },
  {
    header: "SN",
    key: "SN",
  },
  {
    header: "CUSTOMER PO",
    key: "CUSTOMER PO",
  },
  {
    header: "REQUESTED FIELDS",
    key: "REQUESTED FIELDS",
  },
  {
    header: "ACCOMPLISHED DATE",
    key: "ACCOMPLISHED DATE",
  },
  {
    header: "RESPONDED DATE",
    key: "RESPONDED DATE",
  },
  {
    header: "REJECT REMARK",
    key: "REJECT REMARK",
  },
  {
    header: "CREATED BY",
    key: "CREATED BY",
  },
  {
    header: "CREATED DATE",
    key: "CREATED DATE",
  },
  {
    header: "STATUS",
    key: "STATUS",
  },
];

export const CoreInfoRequestExcelName = "Core Info Request List";
